import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import {
  MinusCirlce,
  MinusSquare,
  TickCircle,
  TickSquare,
} from "iconsax-react";
import { memo } from "react";

import type { SefanoCheckboxProps } from "./SefanoCheckbox.types";
import * as styles from "./SefanoCheckbox.styles";

export type { SefanoCheckboxProps } from "./SefanoCheckbox.types";

export const SefanoCheckbox = memo(function SefanoCheckbox({
  label,
  checked = false,
  indeterminate = false,
  variant = "square",
  disabled = false,
  onChange,
}: SefanoCheckboxProps) {
  const theme = useTheme();
  const isCircle = variant === "circle";

  const uncheckedColor = theme.palette.warning.main;
  const checkedColor = theme.palette.success.main;

  const handleToggle = () => {
    if (disabled) return;
    onChange?.(!checked);
  };

  const renderIcon = () => {
    const size = 22;

    if (indeterminate) {
      return isCircle ? (
        <MinusCirlce size={size} variant="Bold" color={uncheckedColor} />
      ) : (
        <MinusSquare size={size} variant="Bold" color={uncheckedColor} />
      );
    }

    if (checked) {
      return isCircle ? (
        <TickCircle size={size} variant="Bold" color={checkedColor} />
      ) : (
        <TickSquare size={size} variant="Bold" color={checkedColor} />
      );
    }

    return isCircle ? (
      <MinusCirlce size={size} variant="Linear" color={uncheckedColor} />
    ) : (
      <MinusSquare size={size} variant="Linear" color={uncheckedColor} />
    );
  };

  return (
    <Box
      component="label"
      sx={{
        ...(styles.root as object),
        ...(disabled ? (styles.rootDisabled as object) : {}),
      }}
      onClick={handleToggle}
    >
      <Box sx={styles.iconWrap}>{renderIcon()}</Box>
      {label ? <Typography sx={styles.label}>{label}</Typography> : null}
    </Box>
  );
});
